// Geolocation Testing Page Js
var GeolocationTestingLanding = function () {
  function init() {
    uiBindings();
  }
  var uiBindings = function () {
    var geolocationCard = document.querySelectorAll(".geolocation-card");
    if (geolocationCard) {
      setupVideos();
      setupGif();
    }
  };

  function setupVideos() {
    var videoCard = document.querySelectorAll(".geolocation-card.video-card");
    if (videoCard) {
      for (var i = 0; i < videoCard.length; i++) {
        videoCard[i].addEventListener("mouseover", videoCardHover);
        videoCard[i].addEventListener("mouseleave", videoCardLeave);
      }
    }

    function videoCardHover() {
      var elem = this.getElementsByTagName("video");
      if (elem.length > 0) {
        var playCheck = elem[0].currentTime > 0 
        && !elem[0].paused 
        && !elem[0].ended 
        && elem[0].readyState > 2;
        if(!playCheck) {
          elem[0].play();
        }
      }
    }

    function videoCardLeave() {
      var elem = this.getElementsByTagName("video");
      if (elem.length > 0) {
        var playCheck = elem[0].currentTime > 0 
        && !elem[0].paused 
        && !elem[0].ended 
        && elem[0].readyState > 2;
        if(playCheck) {
          elem[0].pause();
          elem[0].currentTime = 0;
        }
      }
    }
  }
  function setupGif() {
    var imgs = document.querySelectorAll(".geolocation-card.img-card img");
    if (imgs.length > 0) {
      for (var i = 0; i < imgs.length; i++) {
        var hoverImgURL = imgs[i].getAttribute("data-hover"),
          tmpImg = new Image();
        tmpImg.src = hoverImgURL;
      }
    }

    var imgCard = document.querySelectorAll(".geolocation-card.img-card");
    if (imgCard) {
      for (var i = 0; i < imgCard.length; i++) {
        imgCard[i].addEventListener("mouseover", imgCardHover);
        imgCard[i].addEventListener("mouseleave", imgCardLeave);
      }
    }

    function imgCardHover() {
      var elem = this.getElementsByTagName("img");
      if (elem.length > 0) {
        var hoverImgURL = elem[0].getAttribute("data-hover");
        elem[0].src = hoverImgURL;
      }
    }

    function imgCardLeave() {
      var elem = this.getElementsByTagName("img");
      if (elem.length > 0) {
        var staticImgURL = elem[0].getAttribute("data-static");
        elem[0].src = staticImgURL;
      }
    }
  }

  init();
};

document.addEventListener("DOMContentLoaded", function () {
  GeolocationTestingLanding();
});
